import React from "react";
import {
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Message } from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LanguageIcon from "@mui/icons-material/Language";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function JobSeekerDrawer({
  jobSearchMenu,
  advancedsearchfn,
  AppliedJobs,
}) {
  const redirect = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const language = localStorage.getItem("language");
  const toggleDrawer = (isOpen) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpen(isOpen);
  };
  const Labels = useSelector((state) => state.allLabels.labels);
  return (
    <div>
      <Button onClick={toggleDrawer(true)}>
        {<MenuIcon sx={{ color: "#005F8E", fontSize: "40px" }} />}
      </Button>
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        <div
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
          style={{ marginTop: "50px" }}
        >
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                ":hover": {
                  backgroundColor: "#1b765d17",
                },
                cursor: "pointer",
                width: "250px",
              }}
            >
              <ListItemIcon sx={{ color: "#005F8E" }}>
                <LanguageIcon />
              </ListItemIcon>
              <ListItemText
                sx={{
                  color: "#005F8E",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                }}
                primary={
                  language === "pl"
                    ? "Polish"
                    : language === "de"
                    ? "German"
                    : language === "es"
                    ? "Spanish"
                    : "English"
                }
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {
                redirect("/message");
              }}
            >
              <ListItemIcon sx={{ color: "#005F8E" }}>
                <Message />
              </ListItemIcon>
              <ListItemText
                sx={{
                  color: "#005F8E",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                }}
                primary={Labels?.Messages}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {
                redirect("/notifications");
              }}
            >
              <ListItemIcon sx={{ color: "#005F8E" }}>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText
                sx={{
                  color: "#005F8E",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                }}
                primary={Labels?.Notifications}
              />
            </ListItemButton>
          </ListItem>
          {location.pathname === "/jobList" && (
            <ListItem disablePadding>
              <ListItemButton onClick={advancedsearchfn}>
                <ListItemIcon sx={{ color: "#005F8E" }}>
                  <SearchIcon />
                </ListItemIcon>
                <ListItemText
                  sx={{
                    color: "#005F8E",
                    fontFamily: "Poppins",
                    fontSize: "18px",
                  }}
                  primary={Labels.AdvancedSearch}
                />
              </ListItemButton>
            </ListItem>
          )}

          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {
                redirect("/appliedJobs");
              }}
            >
              <ListItemIcon sx={{ color: "#005F8E" }}>
                <WorkHistoryIcon />
              </ListItemIcon>
              <ListItemText
                sx={{
                  color: "#005F8E",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                }}
                primary={`${Labels.appliedJobs} : ${AppliedJobs.length}`}
              />
            </ListItemButton>
          </ListItem>
        </div>
      </Drawer>
    </div>
  );
}
